import React from "react"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"

const EnglishBreadcrumb = props => {
  const crumbs = [...props.crumbs]
  crumbs.shift()
  crumbs[0].crumbLabel = "home"

  const customCrumbLabel = props.crumbLabel
    .replace("en-us", "")
    .replace("-", " ")
    .replace(/\//g, "")

  return (
    <Breadcrumb
      crumbs={crumbs}
      crumbSeparator=" / "
      crumbLabel={customCrumbLabel}
    />
  )
}

export default EnglishBreadcrumb
